import { render, staticRenderFns } from "./newGenerateCert.vue?vue&type=template&id=1a157e36&scoped=true"
import script from "./newGenerateCert.vue?vue&type=script&lang=js"
export * from "./newGenerateCert.vue?vue&type=script&lang=js"
import style0 from "./newGenerateCert.vue?vue&type=style&index=0&id=1a157e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a157e36",
  null
  
)

export default component.exports